import { ConfigProvider, Tabs } from "antd";
import PropTypes from "prop-types";

function CarDetailTabs({ tabs, active, onChange, children, className = "" }) {
    const items = tabs.map((tab) => ({
        key: String(tab.id),
        label: tab.label,
    }));

    return (
        <ConfigProvider
            theme={{
                components: {
                    Tabs: {
                        inkBarColor: "#5d5dff",
                        itemSelectedColor: "#5d5dff",
                        itemHoverColor: "#5d5dff",
                        itemActiveColor: "#5d5dff",
                    },
                },
            }}>
            <div className={`min-w-0 overflow-hidden rounded-2xl bg-white ${className}`}>
                <Tabs
                    activeKey={String(active)}
                    onChange={(key) => onChange(Number(key))}
                    items={items}
                    className="car-detail-tabs min-w-0 px-2 pt-1 [&_.ant-tabs-nav]:overflow-x-auto [&_.ant-tabs-nav]:overflow-y-hidden [&_.ant-tabs-nav]:[-ms-overflow-style:none] [&_.ant-tabs-nav]:[scrollbar-width:none] [&_.ant-tabs-nav::-webkit-scrollbar]:hidden"
                    tabBarStyle={{ marginBottom: 0 }}
                />
                <div className="min-h-[12rem] min-w-0 overflow-x-auto">{children}</div>
            </div>
        </ConfigProvider>
    );
}

CarDetailTabs.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            label: PropTypes.string.isRequired,
        }),
    ).isRequired,
    active: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
};

export default CarDetailTabs;
